module.exports = __webpack_public_path__ + "img/fail.1766306608134.png";